import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from "../../../../../environments/environment";
import {Page, Pageable} from "../../../../utils/pageable";

import {
  SchoolStudentStatus,
  V3Student,
} from '../../../model/v3/schools';
import {
  appendCollection,
  appendIfDefined,
  createPageableParams,
  serializeDateInput,
} from './rest-v3-utils';
import {StudentV3Api} from "../casa-native-api";

@Injectable({
  providedIn: 'root',
})
export class StudentV3RestService implements StudentV3Api{
  constructor(private http: HttpClient) {}

  private url(schoolId: number, path: string = ''): string {
    return `${environment.eventsApiBase}/v1/schools/${schoolId}/students${path}`;
  }

  getStudents(
    schoolId: number,
    term?: string | null,
    status?: SchoolStudentStatus[] | null,
    expiry?: Date | string | null,
    pageable?: Pageable,
  ): Observable<Page<V3Student>> {
    let params = createPageableParams(pageable);
    params = appendIfDefined(params, 'term', term);
    params = appendCollection(params, 'status', status ?? undefined);
    params = appendIfDefined(params, 'expiry', serializeDateInput(expiry));
    return this.http.get<Page<V3Student>>(this.url(schoolId), { params });
  }

  getStudent(schoolId: number, studentId: number): Observable<V3Student> {
    return this.http.get<V3Student>(this.url(schoolId, `/${studentId}`));
  }
}
